'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { ReactNode } from 'react';

import { ContentModal } from './content-modal.component';

interface ModalProps {
  open: boolean;
  children: ReactNode;
  closable?: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export function Modal({ open, children, closable, onOpenChange }: ModalProps) {
  const isOpen = closable === true ? true : open;

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      {children}
    </Dialog.Root>
  );
}

Modal.Button = Dialog.Trigger;
Modal.Close = Dialog.Close;
Modal.Content = ContentModal;
